export const hideBodyScroll = () => {
  if (typeof window !== 'undefined') {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden'
  }
}

export const showBodyScroll = () => {
  if (typeof window !== 'undefined') {
    document.getElementsByTagName('body')[0].style.overflow = 'auto'
  }
}

export const smoothScroll = () => {
  if (typeof window !== 'undefined') {
    document.getElementsByTagName('html')[0].style.scrollBehavior = 'smooth'
  }
}

export const noSmoothScroll = () => {
  if (typeof window !== 'undefined') {
    document.getElementsByTagName('html')[0].style.scrollBehavior = 'unset'
  }
}

export function mapEdgesToNodes(data) {
  if (!data.edges) return []
  return data.edges.map((edge) => edge.node)
}
